import { sortedArrayByItem } from "../utilities";
import grades from "./grades.json";

export default grades;
